<div class="id-card-container">
  <!-- ID Card Display -->
  <div id="id-card" class="id-card">
    <!-- Card Header with Enhanced Design -->
    <div class="card-header">
      <div class="header-top">
        <div class="school-logo">
          <img [src]="school?.logo || 'assets/images/logo/logo.png'" alt="School Logo" class="logo-img">
        </div>
        <div class="header-info">
          <h3 class="school-name">{{ school?.name || 'School Name' }}</h3>
          <p class="school-motto">{{ school?.motto || 'Excellence in Education' }}</p>
        </div>
        <div class="card-type-badge">
          <span class="badge-text">{{ userType === 'learner' ? 'STUDENT' : 'STAFF' }}</span>
        </div>
      </div>
      <div class="card-subtitle">
        <span class="subtitle-text">IDENTIFICATION CARD</span>
      </div>
    </div>

    <!-- Card Body with Improved Layout -->
    <div class="card-body">
      <!-- Photo Section with Enhanced Styling -->
      <div class="photo-section">
        <div class="photo-container">
          <img [src]="getUserPhoto()" [alt]="getUserName()" class="photo">
          <div class="photo-border"></div>
        </div>
        <div class="photo-label">
          <span>PHOTO</span>
        </div>
      </div>

      <!-- Information Section with Better Typography -->
      <div class="info-section">
        <div class="info-grid">
          <div class="info-row">
            <span class="label">Full Name</span>
            <span class="value">{{ getUserName() }}</span>
          </div>
          
          <div class="info-row">
            <span class="label">{{ userType === 'learner' ? 'Student ID' : 'Employee ID' }}</span>
            <span class="value">{{ getUserId() }}</span>
          </div>

          <div class="info-row" *ngIf="userType === 'learner'">
            <span class="label">Class</span>
            <span class="value">{{ getUserClass() }}</span>
          </div>

          <div class="info-row" *ngIf="userType === 'teacher'">
            <span class="label">Department</span>
            <span class="value">{{ getUserDepartment() }}</span>
          </div>

          <div class="info-row">
            <span class="label">Academic Year</span>
            <span class="value">{{ academicYear || currentYear }}</span>
          </div>

          <div class="info-row">
            <span class="label">Issue Date</span>
            <span class="value">{{ currentYear }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Footer with Enhanced Design -->
    <div class="card-footer">
      <div class="footer-content">
        <div class="validity-info">
          <div class="validity-label">Valid Until</div>
          <div class="validity-date">{{ currentYear + 1 }}</div>
        </div>
        <div class="card-number-info">
          <div class="card-number-label">Card #</div>
          <div class="card-number">{{ getUserId() }}-{{ currentYear }}</div>
        </div>
      </div>
      <div class="security-features">
        <div class="security-dot"></div>
        <div class="security-dot"></div>
        <div class="security-dot"></div>
      </div>
    </div>

    <!-- Background Pattern for Visual Appeal -->
    <div class="card-pattern"></div>
  </div>

  <!-- Enhanced Action Buttons -->
  <div class="card-actions">
    <button 
      pButton 
      type="button" 
      [label]="'COMMON.DOWNLOAD_ID_CARD' | translate" 
      icon="pi pi-download" 
      class="p-button-primary download-btn"
      [disabled]="isDownloading"
      (click)="downloadCard()"
    ></button>
    
    <button 
      pButton 
      type="button" 
      [label]="'COMMON.PRINT_ID_CARD' | translate" 
      icon="pi pi-print" 
      class="p-button-secondary print-btn"
      (click)="printCard()"
    ></button>

    <button 
      pButton 
      type="button" 
      [label]="'COMMON.SHARE' | translate" 
      icon="pi pi-share-alt" 
      class="p-button-outlined share-btn"
      (click)="shareCard()"
    ></button>
  </div>

  <!-- Enhanced Loading Indicator -->
  <div *ngIf="isDownloading" class="loading-overlay">
    <div class="loading-content">
      <div class="loading-spinner">
        <div class="spinner-ring"></div>
      </div>
      <h3>Generating ID Card</h3>
      <p>Please wait while we create your professional ID card...</p>
    </div>
  </div>
</div>